const routes = {
  index: '/',
  about: '/about/',
  howItWorks: '/how-it-works/',
  token: '/token/',
  team: '/team/',
  faq: '/faq/',
  info: '/information/',
  press: '/press/',
  careers: '/careers/',
  privacyPolicy: '/privacy-policy/',
  whitepaper: '/whitepaper/',
  partners: '/partners/',
  guides: '/guides/',
  legalNotices: '/legal-notices/',
  termsOfUse: '/terms-of-use/',
  termsOfSale: '/terms-of-sale/',
  contact: '/contact/',
  blog: '/blog/',
  newsletter: '/newsletter/',
}

export default routes
